import { FormikErrors } from 'formik';
import React, { createContext, ReactNode } from 'react';

import { ModalField, SessionStorageKeys } from '../../types';

export type EmbeddedWidgetContextType<T> = {
  getCustomParamValues: () => Record<string, any>;
  setCurrentWidgetErrors: React.Dispatch<React.SetStateAction<FormikErrors<T>>>;
  currentWidgetErrors: FormikErrors<T> | null;
  sessionStorageKeys?: SessionStorageKeys | undefined;
  modalFields: ModalField[];
};

const EmbeddedWidgetContext = createContext<EmbeddedWidgetContextType<any> | undefined>(undefined);

const EmbeddedWidgetProvider = <T,>({
  children,
  currentWidgetErrors,
  getCustomParamValues,
  sessionStorageKeys,
  setCurrentWidgetErrors,
  modalFields,
}: {
  children: ReactNode;
  currentWidgetErrors: FormikErrors<T> | null;
  getCustomParamValues: () => Record<string, any>;
  modalFields: ModalField[];
  sessionStorageKeys?: SessionStorageKeys;
  setCurrentWidgetErrors: React.Dispatch<React.SetStateAction<FormikErrors<T>>>;
}) => {
  const value = React.useMemo(
    () => ({
      currentWidgetErrors,
      getCustomParamValues,
      modalFields,
      sessionStorageKeys,
      setCurrentWidgetErrors,
    }),
    [currentWidgetErrors, getCustomParamValues, modalFields, sessionStorageKeys, setCurrentWidgetErrors],
  );

  return <EmbeddedWidgetContext.Provider value={value}>{children}</EmbeddedWidgetContext.Provider>;
};

export { EmbeddedWidgetContext, EmbeddedWidgetProvider };
